import { BasePage } from '@/components/ui/base-page'

export function AlternativesPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add AlternativesPage specific content here */}
    </BasePage>
  )
}